import React from 'react';

export const ReduxKeyContext = React.createContext();